import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import {
  CANCEL_GROUP_ORDER_CONFIRMATION_MODAL,
  GROUP_ORDER_CHECKOUT_CONFIRMATION_MODAL,
  LEAVE_GROUP_ORDER_MODAL
} from 'constants/cart';
import CartConfirmation from 'components/Cart/CartConfirmation';
import CancelGroupOrderConfirmation from 'bento-ordering/group_ordering/components/CancelGroupOrderConfirmation';
import GroupOrderCheckoutConfirmation from 'bento-ordering/group_ordering/components/GroupOrderCheckoutConfirmation';
import { clearCart } from 'bento-ordering/cart/actions/index';
import { goToMenu } from 'bento-ordering/cart/actions/orderSettings';
import {
  selectCartGroupOrderAdminName,
  selectCartGroupOrderSlug,
  selectGroupOrderCurrentDinerUUID,
  selectGroupOrderErrorIs404
} from 'bento-ordering/cart/selectors/index';
import { leaveGroupOrder } from 'bento-ordering/group_ordering/actions/index';
import { useRedirectToOOMenu } from 'bento-ordering/group_ordering/hooks';
import { SET_SEAT_ID_MODAL } from 'bento-ordering/investor_day/constants';
import SelectSeatIdModal from 'bento-ordering/investor_day/components/SelectSeatIdModal';

function CartConfirmModal({ toggleIsOpen, modalType }) {
  const theme = useTheme();
  const isSmallUp = useMediaQuery(theme.breakpoints.up('sm'));
  const dispatch = useDispatch();

  const groupOrderAdminName = useSelector(selectCartGroupOrderAdminName);
  const groupOrderSlug = useSelector(selectCartGroupOrderSlug);
  const groupOrderDinerUUID = useSelector(selectGroupOrderCurrentDinerUUID);
  const errorIs404NotFound = useSelector(selectGroupOrderErrorIs404);

  const redirectToOO = useRedirectToOOMenu();

  const emptyCart = () => {
    dispatch(clearCart());
    dispatch(goToMenu());
  };

  const handleLeaveGroupOrder = async () => {
    if (errorIs404NotFound) {
      redirectToOO();
      return;
    }
    const result = await dispatch(
      leaveGroupOrder(groupOrderSlug, groupOrderDinerUUID)
    );
    if (result?.error !== true) {
      redirectToOO();
    }
  };

  const getModal = () => {
    let modal = null;

    switch (modalType) {
      case CANCEL_GROUP_ORDER_CONFIRMATION_MODAL:
        modal = <CancelGroupOrderConfirmation toggleIsOpen={toggleIsOpen} />;
        break;

      case GROUP_ORDER_CHECKOUT_CONFIRMATION_MODAL:
        modal = <GroupOrderCheckoutConfirmation toggleIsOpen={toggleIsOpen} />;
        break;

      case SET_SEAT_ID_MODAL:
        modal = <SelectSeatIdModal toggleIsOpen={toggleIsOpen} />;
        break;

      default:
        modal = (
          <CartConfirmation
            onCancel={toggleIsOpen}
            onConfirm={
              modalType === LEAVE_GROUP_ORDER_MODAL
                ? handleLeaveGroupOrder
                : emptyCart
            }
            modalType={modalType}
            groupOrderAdminName={groupOrderAdminName}
            errorIs404NotFound={errorIs404NotFound}
          />
        );
        break;
    }

    return modal;
  };

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent={isSmallUp ? 'flex-start' : 'center'}
    >
      {getModal()}
    </Box>
  );
}

CartConfirmModal.propTypes = {
  toggleIsOpen: PropTypes.func,
  handleConfirm: PropTypes.func,
  modalType: PropTypes.string,
  groupOrderAdminName: PropTypes.string
};

export default CartConfirmModal;
